/* 南方洋行 · 送料の目安（snippets/nanpo-ship-estimate.liquid，2026-10-09）
   价目来自店铺元字段 nanpo.shipping_estimate：每个地区、每种寄法是 [下限 g, 上限 g, 运费 円] 的档位，按「商品重量」查，
   和结账页一样（包装重量已经在档位里扣掉了）。
   - product：商品重量 = 购物车里已有的 + 这件商品的重量 × 数量框里的数。加购以后重新取 /cart.js；换款式时换单件重量
   - cart：购物车的总重量，改数量后用 cartUpdate 返回的 total_weight
   - page：选 LP 张数，每张 300 g
   超过上限（1,800 g）只显示「每单 6 张」的说明；某种寄法在这个重量没有档位就写「この重さでは選べません」。
   例外（10/11）：日本国内的レターパックプラス（0～299 g，CD 3 枚まで・軽いグッズのみ）和ゆうパック（300 g 起）按重量二选一，
   结账时只会出现一种，所以有一种能用时，另一种不列出来。
   选过的地区记在 localStorage（只为下次打开方便，读写失败也不影响）。 */
if (!customElements.get('nh-ship-est')) {
  class NhShipEst extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-nh-est-data]').textContent);
        this.t = JSON.parse(this.querySelector('[data-nh-est-text]').textContent);
      } catch (e) {
        return;
      }
      this.mode = this.dataset.mode;
      this.base = parseInt(this.dataset.base, 10) || 0;
      this.unit = parseInt(this.dataset.unit, 10) || 0;
      this.sel = this.querySelector('[data-region]');
      this.rows = this.querySelector('[data-rows]');
      this.basis = this.querySelector('[data-basis]');
      this.count = this.querySelector('[data-count]');

      let saved = '';
      try { saved = localStorage.getItem('nh-est-region') || ''; } catch (e) { /* 无痕模式等 */ }
      const pre = saved || this.dataset.pre || '';
      if (pre && this.sel.querySelector(`option[value="${pre}"]`)) this.sel.value = pre;
      this.sel.addEventListener('change', () => {
        try { localStorage.setItem('nh-est-region', this.sel.value); } catch (e) { /* 同上 */ }
        this.render();
      });
      if (this.count) this.count.addEventListener('change', () => this.render());

      if (this.mode === 'product') {
        this.qty = this.dataset.form ? document.querySelector(`.quantity__input[form="${this.dataset.form}"]`) : null;
        if (this.qty) ['input', 'change'].forEach(ev => this.qty.addEventListener(ev, () => this.render()));
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, e => {
          const w = e && e.cartData && e.cartData.total_weight;
          if (this.mode === 'cart' && typeof w === 'number') {
            this.base = w;
            this.render();
          } else if (this.mode === 'product') {
            const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            fetch(`${root}cart.js`).then(r => r.json()).then(c => { this.base = c.total_weight || 0; this.render(); }).catch(() => {});
          }
        });
        if (this.mode === 'product' && PUB_SUB_EVENTS.variantChange) {
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, e => {
            const v = e && e.data && e.data.variant;
            if (v && typeof v.weight === 'number') { this.unit = Math.ceil(v.weight); this.render(); }
          });
        }
      }
      this.render();
    }

    disconnectedCallback() {
      if (this.unsubCart) this.unsubCart();
      if (this.unsubVariant) this.unsubVariant();
    }

    amount() {
      if (this.mode === 'page') return Math.max(1, parseInt(this.count && this.count.value, 10) || 1);
      if (this.mode === 'product') return Math.max(1, parseInt(this.qty && this.qty.value, 10) || 1);
      return 0;
    }

    weight() {
      if (this.mode === 'page') return this.unit * this.amount();
      if (this.mode === 'product') return this.base + this.unit * this.amount();
      return this.base;
    }

    fill(s, vars) {
      return Object.keys(vars).reduce((acc, k) => acc.split(`{${k}}`).join(vars[k]), s);
    }

    yen(n) {
      return this.fill(this.t.yen, { n: n.toLocaleString('en-US') });
    }

    el(tag, cls, text) {
      const e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }

    render() {
      const t = this.t;
      const key = this.sel.value;
      const w = this.weight();
      this.rows.replaceChildren();
      this.basis.textContent = '';
      if (!key) {
        this.rows.append(this.el('li', 'nh-est__hint', t.pick));
        return;
      }
      const zone = this.data.zones[key === 'hk' || key === 'mo' ? 'hkmo' : key];
      if (!zone) return;
      if (w > this.data.cap_g) {
        this.rows.append(this.el('li', 'nh-est__over', t.over));
      } else {
        const fits = m => m.t.find(([lo, hi]) => w >= lo && w <= hi);
        const anyFits = zone.methods.some(fits);
        zone.methods.forEach(m => {
          const tier = fits(m);
          if (!tier && anyFits && (m.m === 'letterpack' || m.m === 'yupack')) return;
          const li = this.el('li', `nh-est__row${tier ? '' : ' is-na'}`);
          const name = this.el('span', 'nh-est__m');
          name.append(this.el('b', null, t[`m_${m.m}`] || m.m));
          const days = m.days ? this.fill(t.days, { d: m.days.replace(/[〜~]/g, t.sep) }) : '';
          const desc = tier ? [t[`d_${m.m}`], days].filter(Boolean).join(' · ') : t.na;
          name.append(this.el('small', null, desc));
          li.append(name, this.el('span', 'nh-est__p nh-mono', tier ? this.yen(tier[2]) : '—'));
          this.rows.append(li);
        });
      }
      const g = w.toLocaleString('en-US');
      if (this.mode === 'page') this.basis.textContent = this.fill(t.b_page, { n: this.amount(), g });
      else if (this.mode === 'product') this.basis.textContent = this.fill(this.base > 0 ? t.b_product_cart : t.b_product, { n: this.amount(), g });
      else this.basis.textContent = this.fill(t.b_cart, { g });
    }
  }
  customElements.define('nh-ship-est', NhShipEst);
}
